<template>
  <div class="fab-container">
    <div class="fab-parent fab-icon-holder">
      <i class="fa fa-chevron-up"></i>
    </div>
    <ul class="fab-options">
      <li>
        <span class="fab-label">
          <router-link to="/add-employee" class="">
            {{ $t("employeeAdd") }}
          </router-link>
        </span>
        <div class="fab-icon-holder">
          <router-link to="/add-employee" class="">
            <img src="@/assets/images/plus.svg" />
          </router-link>
        </div>
      </li>
      <li>
        <span class="fab-label" @click="open">
          {{ $t("filter") }}
        </span>
        <div class="fab-icon-holder" @click="open">
          <img src="@/assets/images/filter.svg" />
        </div>
      </li>
    </ul>

    <vue-bottom-sheet ref="EmployeeBottomSheet">
      <div class="row">
        <div class="form-label-group col-12">
          <input
            name="textSearch"
            id="textSearch"
            type="text"
            v-model="text"
            class="form-control"
            placeholder=" "
            maxlength="50"
          />
          <label for="textSearch">{{ $t("search") }}</label>
          <img src="@/assets/images/search.svg" />
        </div>

        <CustomSelectBox
          :className="'col-md-12'"
          :id="'employeeRoleToken'"
          :value="employeeRole"
          :options="employeeRoleTokenOptions"
          v-on:changeValue="employeeRole = $event"
          :title="$t('general.role.select')"
          :imgName="'type.svg'"
        />
      </div>

      <div class="form-footer">
        <button
          name="submit"
          type="submit"
          class="btn btn-submit"
          @click.prevent="search"
        >
          {{ $t("search") }}
        </button>
        <button class="btn btn-cancel" @click.prevent="close">
          {{ $t("cancel") }}
        </button>
      </div>
    </vue-bottom-sheet>
  </div>
</template>

<script>
import { STATUS } from "@/utils/constants";
import { ROLE_TYPE } from "@/utils/constantLists";
import CustomSelectBox from "@/components/general/CustomSelectBox.vue";
// import UserRole from "@/models/settings/settingsOther/userRoles/UserRole";
import axios from "axios";

export default {
  name: "EmployeeFloatBtns",
  components: { CustomSelectBox },
  props: {
    textSearch: {
      type: String,
      default: "",
    },
    employeeRoleToken: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken,
      text: this.textSearch,
      employeeRole: this.employeeRoleToken,
      employeeRoleTokenOptions: [],
    };
  },
  methods: {
    open() {
      this.$refs.EmployeeBottomSheet.open();
    },
    close() {
      this.$refs.EmployeeBottomSheet.close();
    },
    search() {
      this.close();
      this.$emit("search", this.text, this.employeeRole);
    },
    async getDialogOfUserRoles() {
      this.isLoading = true;
      this.employeeRoleTokenOptions = [];
      this.employeeRoleTokenOptions.push({
        value: "",
        text: this.$t("general.role.select"),
      });
      try {
        const response = await axios.get(
          `/EstablishmentRoles/GetDialogOfEstablishmentRoles?language=${this.language}&userAuthorizeToken=${this.userAuthorizeToken}&filterStatus=true&roleTypeToken=${ROLE_TYPE.Employee}`
        );
        const itemsData = response.data.itemsData;
        if (response.data.status == STATUS.SUCCESS) {
          for (let item in itemsData) {
            this.employeeRoleTokenOptions.push({
              value: itemsData[item]["itemToken"],
              text: itemsData[item]["itemName"],
            });
          }
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        }
        this.isLoading = false;
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
        this.employeeRoleTokenOptions = [];
      }
      this.isLoading = false;
    },
  },
  async created() {
    this.getDialogOfUserRoles();
  },
};
</script>
